messageBox = {};

messageBox.setValue = function (value) {
  messageBox.messageText.setText(value);
};

messageBox.setMessage = function (text, translationParams, value, symbolIndex) {
  var args = [];
  if (checkForDefined(translationParams)) {
    for (var i = 1; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
  }
  messageBox.messageText.setTranslationPhrase(text);
  messageBox.messageText.setTranslationParameters.apply(
    messageBox.messageText,
    args
  );
};

messageBox.show = function (canShow) {
  if (canShow) {
    messageBox.backgroundParent.alpha = 0;
    messageBox.backgroundParent.visible = true;
    gsap.to(messageBox.backgroundParent, {
      duration: 0.2,
      alpha: 1,
    });
  } else {
    gsap.to(messageBox.backgroundParent, {
      duration: 0.4,
      alpha: 0,
      onComplete: () => {
        messageBox.backgroundParent.visible = false;
        messageBox.clearMessage();
      },
    });
  }
};

messageBox.clearMessage = function () {
  messageBox.messageText.setText("");
};

messageBox.create = function (json) {
  return new PIXI.Container();
};

messageBox.initialise = function (json, container, resources) {
  messageBox.backgroundParent = resourceManager.createObject(
    "container",
    "parent",
    container.name
  );
  messageBox.background = resourceManager.createObject(
    "sprite",
    "background",
    messageBox.backgroundParent.name,
    { fileName: "Desktop_UI_Default/Total_Win_Bar.png", anchor: 0.5, y: -80 }
  );

  messageBox.messageText = resourceManager.createObject(
    "text",
    "messageText",
    messageBox.background,
    {
      fontDefinition: "gambleFontYellow",
      fontSize: 20,
      text: "",
      anchor: 0.5,
      x: -15,
      y: -6,
      maxWidth: 175,
    }
  );

  messageBox.backgroundParent.visible = false;
};

messageBox.getFilesRequired = function (json) {
  return ["UserInterface/Blank.png"];
};

resourceManager.registerObjectType(
  "messageBox",
  messageBox.create,
  messageBox.initialise,
  messageBox.getFilesRequired
);
